import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import API_BASE from "../config/api";

export default function UserProfile() {
    const [formData, setFormData] = useState({
        id: "",
        fullname: "",
        email_username: "",
        mobile: "",
        password: ""
    });

    const [isGoogleUser, setIsGoogleUser] = useState(false);
    const defaultImage = "https://images.dialnepal.com.np/default.png";

    const userId = new URLSearchParams(window.location.search).get("userid");

    useEffect(() => {
        if (!userId) return;

        fetch(`${API_BASE}/api/get_user_data.php?userid=${userId}`)
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    const u = data.user;
                    setFormData({
                        id: u.id,
                        fullname: u.fullname || "",
                        email_username: u.email || u.username || "",
                        mobile: u.mobile || "",
                        password: ""
                    });
                    setIsGoogleUser(u.login_type === "google");
                } else {
                    Swal.fire("Error", data.message, "error");
                }
            })
            .catch(() => Swal.fire("Error", "Failed to load user data", "error"));
    }, [userId]);

    const updateField = (e) => {
        if (isGoogleUser) return;
        setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSave = async () => {
        try {
            const res = await fetch(`${API_BASE}/api/update_user_profile.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            const data = await res.json();

            if (data.success) {
                Swal.fire("Success!", "Profile updated successfully", "success");
            } else {
                Swal.fire("Error!", data.message, "error");
            }
        } catch {
            Swal.fire("Error!", "Failed to save profile", "error");
        }
    };

    return (
        <div className="container py-4" style={{ maxWidth: "700px" }}>

            {/* THEME HEADER */}
            <div
                className="rounded p-3 mb-3 shadow-sm"
                style={{
                    background: "linear-gradient(135deg, #e8f0ff, #fefefe)",
                    borderLeft: "6px solid #4a90e2"
                }}
            >

                <h5 className="fw-bold text-dark mb-1">
                    <i className="bi bi-person-badge-fill text-primary me-2"></i>
                    User Profile
                </h5>
                <p className="text-secondary mb-0">
                    View and update your account details.
                </p>
            </div>

            {/* MAIN CARD */}
            <div className="card border-0 shadow-sm rounded-4">
                <div className="card-body px-4 py-4">

                    {/* PROFILE IMAGE */}
                    <div className="text-center mb-4">
                        <img
                            src={defaultImage}
                            width="120"
                            height="120"
                            className="rounded-circle shadow-sm border"
                            alt="profile"
                        />

                        {isGoogleUser && (
                            <div
                                className="mt-3 p-2 rounded-3 text-danger fw-semibold"
                                style={{
                                    background: "#fff4f4",
                                    border: "1px solid #ffd3d3",
                                    display: "inline-block",
                                    fontSize: "14px"
                                }}
                            >
                                <i className="bi bi-google me-1"></i>
                                Google Login – Profile Editing Disabled
                            </div>
                        )}
                    </div>

                    {/* FULL NAME */}
                    <div className="mb-3">
                        <label className="fw-semibold mb-1">Full Name</label>
                        <input
                            type="text"
                            className="form-control form-control-lg rounded-3"
                            name="fullname"
                            value={formData.fullname}
                            onChange={updateField}
                            disabled={isGoogleUser}
                        />
                    </div>

                    {/* EMAIL / USERNAME */}
                    <div className="mb-3">
                        <label className="fw-semibold mb-1">Email / Username</label>
                        <input
                            type="text"
                            className="form-control form-control-lg rounded-3"
                            name="email_username"
                            value={formData.email_username}
                            onChange={updateField}
                            disabled={isGoogleUser}
                        />
                    </div>

                    {/* MOBILE */}
                    <div className="mb-3">
                        <label className="fw-semibold mb-1">Mobile</label>
                        <input
                            type="text"
                            className="form-control form-control-lg rounded-3"
                            name="mobile"
                            value={formData.mobile}
                            onChange={updateField}
                            disabled={isGoogleUser}
                        />
                    </div>

                    {/* PASSWORD */}
                    <div className="mb-3">
                        <label className="fw-semibold mb-1">Password</label>
                        <input
                            type="password"
                            className="form-control form-control-lg rounded-3"
                            name="password"
                            placeholder="Enter new password (optional)"
                            onChange={updateField}
                            disabled={isGoogleUser}
                        />
                    </div>

                    {/* SAVE BUTTON */}
                    {!isGoogleUser && (
                        <button
                            className="btn btn-primary btn-lg w-100 rounded-3 mt-2"
                            onClick={handleSave}
                        >
                            Save Profile
                        </button>
                    )}
                </div>
            </div>

            {/* EXTRA UI BEAUTY */}
            <style>{`
                .form-control:focus {
                    border-color: #4a90e2;
                    box-shadow: 0 0 0 0.2rem rgba(74, 144, 226, 0.25);
                }
            `}</style>
        </div>
    );
}
